import { Box, Button, Link as MuiLink, Paper, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  getOrderInformation,
  getOrderInformationAfterPayment,
} from '../../api/subscriptions';

const CheckoutForm = () => {
  const [checkoutData, setCheckoutData] = useState({});
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const paymentIdAfterPayment = searchParams.get('paymentId');
  const isOrderState = location.state && location.state.orderId;

  useEffect(() => {
    if (location.state?.orderId) {
      getOrderInformation(location.state.orderId)
        .then((data) => setCheckoutData(data.data))
        .catch((error) => console.error(error));
    } else if (paymentIdAfterPayment) {
      getOrderInformationAfterPayment(paymentIdAfterPayment)
        .then((data) => {
          setCheckoutData(data.data);
        })
        .catch((error) => console.error(error));
    }
  }, []);

  return (
    <Box display='flex' justifyContent='center' mt={4}>
      <Paper
        justifyContent='center'
        elevation={3}
        sx={{ padding: 4, maxWidth: 700, width: '100%' }}
      >
        {paymentIdAfterPayment && (
          <>
            <Typography variant='h5' gutterBottom>
              {checkoutData.PaymentStatus === 'Succeeded'
                ? 'Sikeres fizetés'
                : 'Hiba történt a fizetés során!'}
            </Typography>

            <Box my={2} display='flex' justifyContent='center'>
              <img
                src={`${process.env.PUBLIC_URL}/img/barion-card-strip-intl__medium.png`}
                alt='Barion Logo'
                style={{ maxWidth: 300 }}
              />
            </Box>

            <Typography>
              Fizetés azonosítója: {checkoutData.barion_payment_id}
            </Typography>
            <Typography>
              Fizetett összeg: {checkoutData.subscription_price} Ft
            </Typography>
            <Typography>
              Fizetés dátuma: {checkoutData.payment_at_str}
            </Typography>
            <Typography>
              Megrendelés száma: {checkoutData.OrderNumber}
            </Typography>

            <Box mt={2}>
              <MuiLink component={Link} to='/home'>
                Visszalépés a főmenübe
              </MuiLink>
            </Box>
          </>
        )}

        {isOrderState && (
          <>
            <Typography variant='h5' gutterBottom>
              Megrendelés száma: {checkoutData.OrderNumber}
            </Typography>

            {checkoutData.PaymentMethod === 'BANK_CARD' && (
              <Box
                className='payment-order-buttons'
                sx={{
                  justifyContent: 'center',
                  gap: 2,
                  mt: 3,
                }}
              >
                <Typography>
                  Megrendelésed majdnem kész, már csak a fizetés van hátra.
                </Typography>
                <Typography sx={{ mt: 1 }}>
                  A bankkártyás fizetés megkezdéséhez és a Barion fizetési
                  szolgáltatás használatához kattints az alábbi gombra.
                </Typography>

                {/*checkoutData.coupon_code === 'KUPON_NINCS_MOST' && (
                  <Typography color='success.main' sx={{ mt: 1 }}>
                    Aktív kupon: {checkoutData.coupon_code} – egy hetes ingyenes
                    előfizetés
                  </Typography>
                )*/}

                <Box my={2} display='flex' justifyContent='center'>
                  <img
                    src={`${process.env.PUBLIC_URL}/img/barion-card-strip-intl__medium.png`}
                    alt='Barion Logo'
                    style={{ maxWidth: 300 }}
                  />
                </Box>

                <Button
                  variant='contained'
                  color='success'
                  component={Link}
                  to={checkoutData.barion_payment_url}
                >
                  Barion fizetés indítása
                </Button>
              </Box>
            )}

            {checkoutData.PaymentMethod === 'BANK_TRANSFER' && (
              <>
                <Typography>
                  Átutalásos fizetési módot választottál. A profilodban megadott
                  e-mail címre elküldtük a{' '}
                  <strong>{checkoutData.proforma_invoice_nr}</strong> sorszámú
                  díjbekérőt.
                </Typography>
                <Typography mt={1}>
                  Amint az átutalás megtörtént, a szolgáltatás legkésőbb 24 órán
                  belül aktiválásra kerül.
                </Typography>

                <Box mt={2}>
                  <MuiLink component={Link} to='/home'>
                    Visszalépés a kezdőlapra
                  </MuiLink>
                </Box>
              </>
            )}
          </>
        )}
      </Paper>
    </Box>
  );
};

export default CheckoutForm;
